export const countConversationsCreatedUniqueCustomer = {
  analysisType: 'count_unique',
  eventCollection: 'conversation.created',
  key: 'countConversationsCreatedUniqueCustomer',
  targetProperty: 'conversation.customer.id',
}
